/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 20.6143C13.0566 21.4799 14.4116 21.9999 15.8891 21.9999C19.2641 21.9999 22 19.2865 22 15.9393C22 13.328 20.3348 11.1023 18 10.25"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 10.2236C3.66962 11.0556 2 13.3006 2 15.9394C2 19.2866 4.68629 22 8 22C11.3137 22 14 19.2866 14 15.9394C14 15.2611 13.8897 14.6089 13.6862 14M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M17.5798 10.2102C17.851 9.52618 18 8.7805 18 8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8C6 8.7805 6.14903 9.52618 6.42018 10.2102C3.87294 10.9036 2 13.2331 2 16C2 19.3137 4.68629 22 8 22C9.53671 22 10.9385 21.4223 12 20.4722C13.0615 21.4223 14.4633 22 16 22C19.3137 22 22 19.3137 22 16C22 13.2331 20.1271 10.9036 17.5798 10.2102Z"
				fill="currentColor"
			/>
			<path
				d="M6 10.2236C3.66962 11.0556 2 13.3006 2 15.9394C2 19.2866 4.68629 22 8 22C11.3137 22 14 19.2866 14 15.9394C14 15.2611 13.8897 14.6089 13.6862 14M12 20.6144C13.0566 21.48 14.4116 22.0001 15.8891 22.0001C19.2641 22.0001 22 19.2866 22 15.9394C22 13.3281 20.3348 11.1025 18 10.2501M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M5.25025 8C5.25025 4.27208 8.27232 1.25 12.0002 1.25C15.7282 1.25 18.7502 4.27208 18.7502 8C18.7502 11.7279 15.7282 14.75 12.0002 14.75C8.27233 14.75 5.25025 11.7279 5.25025 8Z"
				fill="currentColor"
			/>
			<path
				d="M4.31577 10.2321C2.46879 11.4482 1.25024 13.5514 1.25024 15.9394C1.25024 19.6936 4.26523 22.75 8.00024 22.75C11.7353 22.75 14.7502 19.6936 14.7502 15.9394C14.7502 15.7984 14.746 15.6584 14.7376 15.5194C13.8836 15.8304 12.9617 16 12.0002 16C8.35664 16 5.28195 13.5641 4.31577 10.2321Z"
				fill="currentColor"
			/>
			<path
				d="M19.6766 10.2598C19.0853 12.2719 17.7243 13.9546 15.9343 14.9675C15.9778 15.3055 16.0003 15.6501 16.0003 16C16.0003 18.4798 14.8719 20.6962 13.1006 22.1636C13.9531 22.5405 14.8971 22.75 15.8894 22.75C19.6727 22.75 22.7503 19.7066 22.7503 15.9394C22.7503 13.5648 21.527 11.478 19.6766 10.2598Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M13.6862 14C13.8897 14.6089 14 15.2611 14 15.9394C14 19.2866 11.3137 22 8 22C4.68629 22 2 19.2866 2 15.9394C2 14.4354 2.54234 13.0594 3.44024 12M18 10.2501C20.3348 11.1025 22 13.3281 22 15.9394C22 19.2866 19.2641 22.0001 15.8891 22.0001C15.5871 22.0001 15.2903 21.9783 15 21.9364M12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14C15.3137 14 18 11.3137 18 8C18 6.223 17.2275 4.62643 16 3.52779"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 10.2236C3.66962 11.0556 2 13.3006 2 15.9394C2 19.2866 4.68629 22 8 22C11.3137 22 14 19.2866 14 15.9394C14 15.2611 13.8897 14.6089 13.6862 14M12 20.6144C13.0566 21.48 14.4116 22.0001 15.8891 22.0001C19.2641 22.0001 22 19.2866 22 15.9394C22 13.3281 20.3348 11.1025 18 10.2501M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M4.31577 10.2319C2.46879 11.4481 1.25024 13.5513 1.25024 15.9392C1.25024 19.6935 4.26523 22.7499 8.00024 22.7499C11.7353 22.7499 14.7502 19.6935 14.7502 15.9392C14.7502 15.7983 14.746 15.6582 14.7376 15.5193C13.8836 15.8302 12.9617 15.9999 12.0002 15.9999C8.35664 15.9999 5.28195 13.564 4.31577 10.2319Z"
					fill="currentColor"
				/>
				<path
					d="M19.6766 10.2596C19.0853 12.2717 17.7243 13.9545 15.9343 14.9673C15.9778 15.3054 16.0003 15.65 16.0003 15.9998C16.0003 18.4797 14.8719 20.6961 13.1006 22.1635C13.9531 22.5404 14.8971 22.7498 15.8894 22.7498C19.6727 22.7499 22.7503 19.7065 22.7503 15.9392C22.7503 13.5647 21.527 11.4779 19.6766 10.2596Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M5.25024 7.99951C5.25024 4.27159 8.27232 1.24951 12.0002 1.24951C15.7282 1.24951 18.7502 4.27159 18.7502 7.99951C18.7502 11.7274 15.7282 14.7495 12.0002 14.7495C8.27232 14.7495 5.25024 11.7274 5.25024 7.99951Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
